import { useEffect } from "react";
import { useSelector,useDispatch } from "react-redux";
import {getRequestPageData} from '../store/slices/prayerRequestPageSlice';


export const usePrayerRequestPage = () => {

    const dispatch = useDispatch();	
    const requestPageData  = useSelector((state)=>state.requestPage)
  
    useEffect(() => {
     
      if(requestPageData.status=='idle'){
        dispatch(getRequestPageData())
      }
     
    }, []);
  
    return requestPageData?.requestPageData;
}